import { Component, OnInit, Injector } from '@angular/core';
import { window } from 'ngx-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { OrderServiceProxy } from '../../../../../../../shared/service-proxies/service-proxies';
import { ImageModalComponent } from '../../wizards/step3/image-modal/image-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileService } from '../../../shared/services/file.service';
import { saveAs } from 'file-saver';
import { AppComponentBase } from '../../../../../../../shared/app-component-base';
import { AppConsts } from '@shared/AppConsts';

@Component({
  selector: 'kt-my-past-requests',
  templateUrl: './my-past-requests.component.html',
  styleUrls: ['./my-past-requests.component.scss']
})
export class MyPastRequestsComponent extends AppComponentBase implements OnInit {

	approvalDateFilters = [
		//{ key: 0, value: "Hepsi" },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST7DAYS", this.localizationSourceName), value: 7 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST14DAYS", this.localizationSourceName), value: 14 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST21DAYS", this.localizationSourceName), value: 21 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST30DAYS", this.localizationSourceName), value: 30 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST60DAYS", this.localizationSourceName), value: 60 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST90DAYS", this.localizationSourceName), value: 90 },

	]

	//numberOfDaysList = [
	//	{ key: 0, value: 7 },
	//	{ key: 1, value: 14 },
	//	{ key: 2, value: 21 },
	//	{ key: 3, value: 30 },
	//	{ key: 4, value: 60 },
	//	{ key: 5, value: 90 },


	//]

	approvalStatusList =
	[
			{key:0, value: "Hepsi"},
			{key:1, value:"Onaylandı"},
			{key:2, value:"Beklemede"}
	]
	//son kaç günün listesinden seçtiği gün bilgisini tutar.
	//Mesela: son 7 gün gibi.
	selectedLastNumberDayObj;

	selectedApprovalStatusObj;

	//Sayfa ilk yüklendiği anda getirilecek son 7 gün mesela gibi. 
	DefaultSelectedLastNumberDayObj;


	productList = new BehaviorSubject<any[]>([]);

	constructor(private _orderService: OrderServiceProxy,
		private modalService: NgbModal,
		private _fileService: FileService,
		injector: Injector

	) {
		
		super(injector);

	}

	ngOnInit() {

		//this.selectedApprovalStatusObj = this.approvalStatusList[0].key;
		
		////sayfa yüklendiği anda varsayılan seçili olarak gelmesini istediğimiz gün.
		//this.selectedLastNumberDayObj = this.numberOfDaysList[0].key;

		////Sayfa yüklendiği anda son kaç günün listesi isteniyorsa o gün sayısını barındırır.
		//this.DefaultSelectedLastNumberDayObj = this.numberOfDaysList[0];

		this.selectedLastNumberDayObj = this.approvalDateFilters[0];

		var defaultDateValue = this.approvalDateFilters[0].value;

		//Onay durumu da gönderielecek
		this.asyncProductLoadList(defaultDateValue);
	

	}


	asyncProductLoadList(dateValue) {

		//Burak abinin verdiği method buraya yazılacak ve extra olarak gün sayısı method içerisinde verilerek
		//asyncResultproductList içerisine atılacak.
		this._orderService.getPastOrders(dateValue).subscribe(plist => {
			
			var numberholder = 0;

			this.productList.next(plist);
			plist.forEach(obj => {
				numberholder += (+obj.productDeci);
			})

		});
	
	}

	onSelectedNumberOfDays(numberOfDay) {

		//Bu data burak biye gönderielcek ve subscribe ile yakalanan data tekrar behaviour subject ile yakalanacak.
		//ve producrt tekrar balışmış olacak
		console.log(numberOfDay);

		this.asyncProductLoadList(numberOfDay);

	}

	onSelectedApprovalStatus(approvalStatusObj) {

		//Burak Abinin yazdığı methoda girecek ve içerisinden tekrar liste dönderilecek.
		this.asyncProductLoadList(this.selectedLastNumberDayObj);

	}

	btnExportToExcel(isPhoto: boolean) {

		this.selectedLastNumberDayObj;

		//Burak Abinin yazdığı methoda göndericez ve indirme işlemi yapılacak.
		this._orderService.getPastOrdersForExcel(isPhoto, this.selectedLastNumberDayObj.value).subscribe(res => {
			
			var blob = this._fileService.base64toBlob(res.base64, res.fileType);
			const file = new File([blob], res.fileName, { type: res.fileType });

			saveAs(file);
		});
		
	}

	//Fotoğrafların url döndermek için kullanıyoruz.
	getPhotoUrl(kod: string): string {
		return  AppConsts.productImage.url + '/' + kod + '.jpg'
	}


	//Product listesinin üzerinde ki resimlere tıklayınca buradan code göre url oluşturup modal açıp içine basıyoruz.
	openImage(productCode, pName) {

		let imgActualSize = ( AppConsts.productImage.url + '/' + productCode + '.jpg');

		const modalRef = this.modalService.open(ImageModalComponent, {
			size: 'md'
		});

		modalRef.componentInstance.imgActualSize = imgActualSize;
		modalRef.componentInstance.productCode = productCode;
		modalRef.componentInstance.productName = pName;
	}
	
}
